module.exports = __webpack_public_path__ + "img/thumbnail_CommonOstrich_f_albino.9fd85d25.png";